import { styled } from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  text-align: center;
`;

export const ImagePlaceholder = styled.div`
  width: 150px;
  height: 150px;
  background-color: #ddd;
  margin-bottom: 30px;
`;

export const Message = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 25px;

`;

export const LoginButton = styled.button`
  padding: 10px 20px;
  background-color: #225f9b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    background-color: #1a4a75;
  }
`;